var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13218 17.5C5.65037 17.5 5.23792 17.3368 4.89481 17.0104C4.55171 16.684 4.38016 16.2917 4.38016 15.8333V5H3.50415V3.33333H7.88419V2.5H13.1402V3.33333H17.5203V5H16.6443V15.8333C16.6443 16.2917 16.4727 16.684 16.1296 17.0104C15.7865 17.3368 15.3741 17.5 14.8923 17.5H6.13218ZM14.8923 5H6.13218V15.8333H14.8923V5ZM7.88419 14.1667H9.63621V6.66667H7.88419V14.1667ZM11.3882 14.1667H13.1402V6.66667H11.3882V14.1667Z",
    fill: "#244647"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1d845bb5c6efefe3e7a7c9ae54080336.svg";
export { ForwardRef as ReactComponent };